import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex flex-col items-center md:items-start gap-2">
          <img src="https://www.lightwell.cz/media/logo-lightwell.webp" alt="LightWell Logo" className="h-10 w-auto object-contain" />
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">Světelná reklama a LED panely</span>
        </div>
        <div className="text-gray-500 text-sm text-center md:text-left">
          &copy; {new Date().getFullYear()} <strong>www.lightwell.cz</strong>. Všechna práva vyhrazena.
        </div>
        <div className="flex gap-6">
          <Link to="/" className="text-gray-400 hover:text-blue-600 transition-colors text-xs font-bold uppercase tracking-wider">Úvod</Link>
          <Link to="/produkty/ledbary" className="text-gray-400 hover:text-blue-600 transition-colors text-xs font-bold uppercase tracking-wider">Produkty</Link>
          <a href="https://www.lightwell.cz/obchodni-podminky" className="text-gray-400 hover:text-blue-600 transition-colors text-xs font-bold uppercase tracking-wider">Obchodní podmínky</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;